<template>
  <div height="100%" class="stores-card px-3">
    <v-row>
      <v-col cols="7" md="8" class="pl-md-0 pt-0">
        <div
          class="
            font-italic
            primary--text
            text-h5 text-uppercase
            d-flex
            justify-start
          "
        >
          {{ item.title }}
        </div>
        <div v-if="item.address" class="d-flex my-3 align-center">
          <a
            target="_blank"
            class="
              darken--text
              text-sm-body-1 text-caption
              line-height-1
              text-decoration-none
            "
            :href="item.maps"
            ><span class="open-sans">{{ item.address }}</span></a
          >
        </div>
        <div class="pt-3 d-flex flex-wrap store-whatsapp-buttons">
          <v-btn
            v-for="({ phone, label, whatsappLink }, i) in whatsappContacts"
            :key="`${phone}-${i}`"
            class="
              white--text
              font-weight-bold
              primary
              rounded-0
              px-4
              store-whatsapp-button
            "
            height="36px"
            depressed
            :href="whatsappLink"
            target="_blank"
          >
            <v-icon size="22" color="white">fab fa-whatsapp</v-icon>
            <div class="ml-1 text-h6 text-sm-body-1 font-weight-bold">
              <span class="open-sans">{{ label }}</span>
            </div>
          </v-btn>
        </div>
      </v-col>
      <v-col
        cols="5"
        md="4"
        class="d-flex align-center justify-end pr-md-0 pt-0"
      >
        <img
          v-if="item.img"
          :src="item.img"
          class="stores-card-image d-block"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getStoreWhatsappContacts } from "../../utils/storeWhatsappContacts";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    whatsappContacts() {
      if (this.item.whatsappContacts?.length) {
        return this.item.whatsappContacts;
      }

      return getStoreWhatsappContacts(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.stores-card {
  .stores-card-image {
    aspect-ratio: 143 / 109;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }

  .store-whatsapp-buttons {
    gap: 8px;
  }

  .store-whatsapp-button {
    margin-bottom: 8px;
  }
}
</style>
